import OlTileWMS from "ol/source/TileWMS";
import { TranslateService } from "./translate.service";
export class GlobalVar {
  translate: TranslateService;
  hosts: string;
  usernames: String;
  role: string = localStorage.getItem("node_role");
  server: string = localStorage.getItem("node_server");
  IsLoggedIn = () => {
    this.usernames = localStorage.getItem("user");
    if (this.usernames != undefined) {
      return false;
    } else {
      return true;
    }
  };
  checkRole = () => {
    this.role = localStorage.getItem("roles");
    if (this.role == "admin") {
      return false;
    } else {
      return true;
    }
  };
  source = new OlTileWMS({
    url:
      "https://www.deemap.com/DeeMap/gwc/service/wms?customer_key=kBIKpFJY7dcEi23y",
    params: {
      LAYERS: "DeeMap2_THA_Map",
      FORMAT: "image/png8",
      VERSION: "1.1.1",
      SRS: "EPSG:4326",
      TILES: true
    }
  });

  
}



// WEBPACK FOOTER //
// E:/Git_new/IVMS_PRO/web/src/app/global-var.ts